export default class CaseCancelledError extends Error {}